module.exports = __webpack_public_path__ + "img/logo.646eeb24.svg";